export default __webpack_public_path__ + "static/media/NotoSansKR-Medium.f469d8c2.ttf";